import { AbstractModel } from '../base'
import type { IAgreement, IAgreementData } from './agreement.types'

export class Agreement extends AbstractModel implements IAgreement {
  readonly version: string
  readonly title: string
  readonly content: string
  readonly required: boolean = false
  readonly accepted: boolean = false

  constructor(data: IAgreementData) {
    super()

    // Validate data
    const requiredFields: (keyof IAgreementData)[] = ['version', 'title', 'content']
    this.validate(data, requiredFields)

    // Initialize object assuming data valid
    this.version = data.version!
    this.title = data.title!
    this.content = data.content!

    if (data.required !== undefined) {
      this.required = data.required
    }

    if (data.accepted !== undefined) {
      this.accepted = data.accepted
    }
  }
}
